import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo1/ayudarencasa.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo1 } from "../../../routes/Module1";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo1/Actividad6.mp3";

const Actividad6 = () => {
  const infoUnidad = modulo1.content[0];
  const infoAct = modulo1.content[0].activities[5];
  const crumbs = [
    {
      title: modulo1.title,
      url: "/" + modulo1.url,
    },
    {
      title:
        modulo1.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo1.content[0].activities[6].name}`,
    linkNext: `${modulo1.url}/${modulo1.content[0].path}/${modulo1.content[0].activities[6].path}`,
    titlePrev: `${modulo1.content[0].activities[4].name}`,
    linkPrev: `${modulo1.url}/${modulo1.content[0].path}/${modulo1.content[0].activities[4].path}`,
  };
  const metadata = {
    color: modulo1.color,
    title: `${modulo1.title} - ${infoAct.name}`,
    name: modulo1.title
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo1.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">Actividad 6</h2>
      <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-md-6 col-xs-12">
          <img src={Imagen1} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-md-4 col-xs-12">
          <ul className="mt-5">
            <li>
              Todos podemos enseñar y aprender cosas en nuestras familias.
            </li>
            <li>
              Observa la imagen y conversa con un compañero, compañera o
              familiar: ¿quién está enseñando y quién está aprendiendo?
            </li>
            <li>
              Ahora cuéntale a tu compañero, compañera o familiar qué cosas has
              aprendido en tu familia.
            </li>
          </ul>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen la imagen. Dialoguen sobre las
          preguntas. Destaque que la vida en familia nos prepara para la vida en
          la escuela, el trabajo, etc.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad6;
